import css from './Symptoms.module.css';
import {
  H2,
  H3,
  Image,
  PhoneLink,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
  StackedRowSpacing,
} from '../../../../../../core';
import SymptomList from './symptomList/SymptomList';
import {
  Call911Image,
  CallNurseImage,
} from '../../../../../../core/assets/images';
import { Columns } from './columns';

const illnessOrPain: string[] = [
  'Chest pain, heart attack',
  "Can't breathe, choking",
  'Stroke symptoms (sudden weakness on one side or slurred speech)',
  'Seizures without a previous diagnosis or epilepsy',
];

const injuries: string[] = [
  'Head, neck or eye injuries',
  'Falls with injury or while taking blood thinners',
  'Serious burns',
  'Traumatic injuries',
  'Severe bleeding',
  'Severe allergic reactions',
];

const otherEmergent: string[] = [
  'Suspected poisoning or drug overdose',
  'Electrocution',
  'Fainting or losing consciousness',
  'Labor and delivery',
];

const commonAilments: string[] = [
  'Diabetes, high or low blood sugar',
  'Dizziness or lightheaded',
  'Fever (if younger than three months with a 100.4 fever, seek immediate medical care)',
  'Lice',
  'Sick newborn',
  'Suspected allergic reaction',
];

const painsStrainsBurns: string[] = [
  'Head or eye injury',
  'Abdominal pain',
  'Joint, back and neck pain',
  'Minor cuts/scrapes',
  'Broken bones and dislocations',
  'Strains or sprains',
  'Pain in scrotum/testicles',
  'Rash',
  'Recent burns',
  'Severe pain',
  'Swelling or pain in legs',
];

const respiratory: string[] = [
  'Trouble breathing',
  'Respiratory illness (cough, wheezing)',
];

const gastrointestinal: string[] = [
  'Diarrhea',
  'Trouble swallowing',
  'Vomiting',
];

const otherSituations: string[] = [
  'Abnormal pain/bleeding during pregnancy',
  'Child or elder abuse',
  'Domestic abuse, rape, sexual assault',
  'Fast or irregular heartbeat',
  'Heart Failure',
  'Concerns with blood pressure (too high or low)',
  'Thoughts of harm to self or others or suicide',
  'Anxiety or panic attacks',
  'Change in mental state/confusion',
  'Vision changes',
  'Seizures',
];

const Symptoms: React.FC = () => {  
  return (
    <StackedColumn spacing={StackedColumnSpacing.Wider}>
      <StackedColumn>
        <StackedRow spacing={StackedRowSpacing.Tight}>
          <Image
            source={Call911Image}
            width={38}
            height={27}
            alternateText="Call 911"
          />
          <H2 text="Dial 911" />
        </StackedRow>
        <div>
          <H3
            className={css.promptText}
            text="If you are experiencing any of the following, "
          />
          <H3 className={css.emergency} text="please dial 911 immediately:" />
        </div>
        <Columns>
          <StackedColumn>
            <SymptomList
              header="Sudden, ongoing or severe illness or pain"
              symptomList={illnessOrPain}
            />
            <SymptomList
              header="Sudden or severe injuries"
              symptomList={injuries}
            />
          </StackedColumn>
          <SymptomList
            header="Other emergent symptoms"
            symptomList={otherEmergent}
          />
        </Columns>
      </StackedColumn>
      <StackedColumn>
        <StackedRow spacing={StackedRowSpacing.Tight}>
          <Image
            source={CallNurseImage}
            width={24}
            height={24}
            alternateText="Call 911"
          />
          <H2 text="Nurse Line" />
        </StackedRow>
        <div>
          <H3
            className={css.promptText}
            text="If you are experiencing any of the following, please contact our Nurse Line at "
          />
          <PhoneLink phoneNumber="8443426276" includeImage={false} />
          <H3 className={css.promptText} text=":" />
        </div>
        <Columns>
          <StackedColumn>
            <SymptomList
              header="Common ailments"
              symptomList={commonAilments}
            />
            <SymptomList
              header="Pains, strains, burns"
              symptomList={painsStrainsBurns}
            />
          </StackedColumn>
          <StackedColumn>
            <SymptomList header="Respiratory" symptomList={respiratory} />
            <SymptomList
              header="Gastrointestinal"
              symptomList={gastrointestinal}
            />
            <SymptomList
              header="Other emergent symptoms or situations"
              symptomList={otherSituations}
            />
          </StackedColumn>
        </Columns>
      </StackedColumn>
    </StackedColumn>
  );
};

export default Symptoms;
